import { combineReducers } from "@reduxjs/toolkit";
import userDataSlice from "../slices/userDataSlice";
import settingDataSlice from "../slices/settingDataSlice";

export const rootReducer = combineReducers({
    userData: userDataSlice,
    setting: settingDataSlice
})